const translations = {
  'Searching': {
    en: 'Searching',
    es: 'Buscando',
    pt: 'Procurando',
  },
  'Content': {
    en: 'Content',
    es: 'Contenido',
    pt: 'Conteúdo',
  },
  'Teams': {
    en: 'Teams',
    es: 'Equipos',
    pt: 'Time',
  },
}

export default translations